export const DateMode = {
  DATE: 'date',
  TIME: 'time',
  DATE_TIME: 'datetime'
} as const;

export type DateMode = (typeof DateMode)[keyof typeof DateMode];
